module.exports = __webpack_public_path__ + "static/img/SIGMA.fd73ed8a.png";